export default function categoryZone() {
	let zoneId = window.RR_OD_CONFIG?.fallbackCategoryId;

	const classes = {
		link: 'rr-categories__item__link',
		image: 'rr-categories__item__image',
		title: 'rr-categories__item__title',
	};

	function collectCategoryZones(id = window.RR_OD_CONFIG?.fallbackCategoryId) {
		zoneId = id;
		const categoryZonePlacementIds = [];
		const categoriesZones = {};

		if (zoneId) {
			const categoryItems = document.querySelectorAll(
				`.rr-categories[data-zone-category-id=${zoneId}] [data-category-placement]`,
			);

			categoryItems.forEach(item => {
				const placement = item.getAttribute('data-category-placement');
				categoryZonePlacementIds.push(placement);
				categoriesZones[placement] = item;
			});
		}

		return { categoriesZones, categoryZonePlacementIds };
	}

	function renderItems(categoriesZones, results) {
		return new Promise(resolve => {
			if (Object.keys(categoriesZones)?.length > 0 && results?.length > 0) {
				const placeholders = document.querySelectorAll(
					'.rr-categories--placeholder',
				);
				placeholders.forEach(placeholder => {
					placeholder.classList.remove('rr-categories--placeholder');
				});
			}
			results?.forEach(zoneResult => {
				const renderElement = categoriesZones[zoneResult.zoneId];
				if (
					renderElement &&
					zoneResult.categoryURL &&
					zoneResult.defaultImageURL &&
					zoneResult.categoryName
				) {
					// TODO: Refactor this code—HTML elements should be moved to the TAG file.
					// The following code is used to generate the HTML for the rr-categories on the HOME page.
					// TODO: We have placeholder HTML code in the cmscategoryrichrelevancecomponent.jsp, we need to have one source of truth
					const link = document.createElement('a');
					link.setAttribute('href', zoneResult.categoryURL);
					link.classList.add(classes.link);

					const image = document.createElement('img');
					image.setAttribute('data-src', zoneResult.defaultImageURL);
					image.setAttribute('alt', '');
					image.classList.add(classes.image, 'image-lazy-load');

					const title = document.createElement('p');
					title.textContent = zoneResult.categoryName;
					title.classList.add(classes.title, 'h5', 'mb-0');

					link.append(image);
					link.append(title);
					renderElement.replaceChildren(link);
					renderElement.classList.remove('loading');
				}
			});
			resolve();
		});
	}

	function removeEmptyZones() {
		if (zoneId) {
			const categoryItems = document.querySelectorAll(
				`.rr-categories[data-zone-category-id=${zoneId}] [data-category-placement]`,
			);

			categoryItems.forEach(item => {
				if (item.classList.contains('loading')) item.remove();
			});
		}
	}

	function categoriesCarousel(carouselId) {
		if (carouselId) {
			const config = {
				responsiveClass: true,
				dots: false,
				loop: false,
				nav: true,
				responsive: {
					0: {
						loop: true,
						items: 2,
					},
					480: {
						items: 3,
					},
					992: {
						autoWidth: false,
						items: 6,
					},
				},
			};

			const catZonesCarousel = document.querySelectorAll(
				`[data-zone-category-id=${carouselId}][data-recommended-cat-carousel]`,
			);

			catZonesCarousel.forEach(carousel => {
				window.od.carousel(carousel, config);
			});
		}
	}

	function renderZones(categoriesZones, results) {
		return renderItems(categoriesZones, results)
			.then(removeEmptyZones(zoneId))
			.then(categoriesCarousel(zoneId));
	}

	return { collectCategoryZones, renderZones };
}
